import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "input-group" };
const _hoisted_2 = ["type", "id", "placeholder", "disabled", "value", "min", "max", "step"];
const _hoisted_3 = {
    key: 0,
    class: "input-group-append"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("span", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("input", {
                ref: "inputElem",
                type: _ctx.type,
                class: _normalizeClass('form-control form-control-sm' +
                    (_ctx.type === 'color' ? ' form-control-color' : '') +
                    (_ctx.type === 'range' ? ' form-range border-0 shadow-none' : '')),
                id: _ctx.id,
                placeholder: _ctx.placeHolder,
                disabled: _ctx.disabled,
                onInput: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                onKeydown: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
                value: _ctx.modelValue,
                min: _ctx.min,
                max: _ctx.max,
                step: _ctx.step
            }, null, 42, _hoisted_2),
            (_ctx.actionBtnTxt !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.onActionBtnClick && _ctx.onActionBtnClick(...args))),
                        class: "btn btn-primary",
                        type: "button"
                    }, _toDisplayString(_ctx.actionBtnTxt), 1)
                ]))
                : _createCommentVNode("", true)
        ]),
        _createVNode(_component_FormElementDescription, {
            description: _ctx.descriptionToUse,
            validate: _ctx.validateDescription,
            warning: _ctx.warning
        }, null, 8, ["description", "validate", "warning"])
    ]));
}
